/**
 * icons.tsx
 * ----------------
 * Functions and other content relating to defining the app's icon language.
 */

import { registerIcons } from '@fluentui/react/lib/Styling';
import * as React from 'react';

import {
    BullseyeIcon,
    CalculatorAdditionIcon,
    CalendarIcon,
    ChatIcon,
    CheckmarkIcon,
    ChevronDownIcon,
    ChevronDownMedIcon,
    ChevronUpMedIcon,
    ChromeCloseIcon,
    CircleCheckIcon,
    ClearIcon,
    ClockIcon,
    DotIcon,
    DoubleColumnEditIcon,
    DownIcon,
    EditIcon,
    FeedbackIcon,
    FilterIcon,
    GitHubCodespacesIcon,
    IdentitySignInIcon,
    IntellicodeIcon,
    LicensingIcon,
    LiveShareIcon,
    MarketplaceIcon,
    NuGetIcon,
    OfflineOneDriveParachuteIcon,
    PageListFilterIcon,
    ReceiptCheckIcon,
    ReceiptUndeliveredIcon,
    RemoveFromShoppingListIcon,
    RoamingIcon,
    ShareIcon,
    SortDownIcon,
    SortUpIcon,
    SpeedHighIcon,
    UpIcon,
    VisualStudioCopilot,
    VisualStudioSetupIcon,
} from './components/shared/FluentSvgIcon';

/**
 * Define icons for the app using SVG implementations.
 */
export function defineIconsUsingSvg() {
    registerIcons({
        icons: {
            Bullseye: <BullseyeIcon />,
            CalculatorAddition: <CalculatorAdditionIcon />,
            Calendar: <CalendarIcon />,
            Cancel: <ChromeCloseIcon />,
            Chat: <ChatIcon />,
            Checkmark: <CheckmarkIcon />,
            ChevronDown: <ChevronDownIcon />,
            ChevronDownMed: <ChevronDownMedIcon />,
            ChevronUpMed: <ChevronUpMedIcon />,
            ChromeClose: <ChromeCloseIcon />,
            CircleCheck: <CircleCheckIcon />,
            Clear: <ClearIcon />,
            Clock: <ClockIcon />,
            Dot: <DotIcon />,
            DoubleColumnEdit: <DoubleColumnEditIcon />,
            Down: <DownIcon />,
            Edit: <EditIcon />,
            Feedback: <FeedbackIcon />,
            Filter: <FilterIcon />,
            GitHubCodespaces: <GitHubCodespacesIcon />,
            IdentitySignIn: <IdentitySignInIcon />,
            Intellicode: <IntellicodeIcon />,
            Licensing: <LicensingIcon />,
            LiveShare: <LiveShareIcon />,
            Marketplace: <MarketplaceIcon />,
            NuGet: <NuGetIcon />,
            OfflineOneDriveParachute: <OfflineOneDriveParachuteIcon />,
            PageListFilter: <PageListFilterIcon />,
            ReceiptCheck: <ReceiptCheckIcon />,
            ReceiptUndelivered: <ReceiptUndeliveredIcon />,
            RemoveFromShoppingList: <RemoveFromShoppingListIcon />,
            Roaming: <RoamingIcon />,
            Setup: <VisualStudioSetupIcon />,
            Share: <ShareIcon />,
            SortDown: <SortDownIcon />,
            SortUp: <SortUpIcon />,
            SpeedHigh: <SpeedHighIcon />,
            Up: <UpIcon />,
            VisualStudioCopilot: <VisualStudioCopilot />,
        },
    });
}
